export default __webpack_public_path__ + "static/media/forestly-expl-intro_DE.8af4361d.png";